import { createGlobalStyle } from 'styled-components';
import { COLORS, FONT_WEIGHTS } from './utils';

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${(props) => props.theme.font.default};
    font-size: ${(props) => props.theme.fontSize.default};
    color: ${COLORS.TEXT};
    background-color: ${COLORS.BACKGROUND};
    font-weight: ${FONT_WEIGHTS.DEFAULT};
    margin: 0;
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  * {
    box-sizing: border-box;
  }

  :is(a, button, summary, input, textarea, select, h1, h2, h3, h4) {
    --outline-size: max(2px, 0.08em);
    --outline-style: solid;
    --outline-color: black;
    --outline-offset: 2px;
  }

  :is(a, button, summary, input, textarea, select, h1, h2, h3, h4):focus {
      outline: var(--outline-size) var(--outline-style) var(--outline-color);
      outline-offset: var(--outline-offset, var(--outline-size));
  }

  :is(a, button, summary, input, textarea, select, h1, h2, h3, h4):focus-visible {
      outline: var(--outline-size) var(--outline-style) var(--outline-color);
      outline-offset: var(--outline-offset, var(--outline-size));
  }

  :is(a, button, summary, input, textarea, select, h1, h2, h3, h4):focus:not(:focus-visible) {
    outline: none;
  }
`;
